import { render, staticRenderFns } from "./StoreCouponClaimValidDays.vue?vue&type=template&id=bce2f902"
import script from "./StoreCouponClaimValidDays.vue?vue&type=script&lang=js"
export * from "./StoreCouponClaimValidDays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports